module.exports = __webpack_public_path__ + "img/transfer_detail_tjimg.eb3d1c96.png";